import { FC, ReactNode } from 'react';
import PropTypes from 'prop-types';
import { Box, Container, styled } from '@mui/material';

const PageTitle = styled(Box)(
  ({ theme }) => `
        padding: ${theme.spacing(4)};
`
);

interface PageTitleWrapperProps {
  isUsersPage?:boolean;
  children?: ReactNode;
}

const PageTitleWrapper: FC<PageTitleWrapperProps> = ({ isUsersPage= false,children }) => {
  return (
    <PageTitle className="MuiPageTitle-wrapper">
      <Container maxWidth={isUsersPage ? false : "lg"} sx={{ maxWidth: isUsersPage ? "1600px" : "1280px" }} >{children}</Container>
    </PageTitle>
  );
};

PageTitleWrapper.propTypes = {
  children: PropTypes.node.isRequired
};

export default PageTitleWrapper;
